import h from "./html";
import Db from "./db";
import ImportIcs from "./ImportIcs";

const CalendarPicker = ({
  db,
  selectedCalendarsJson,
}: {
  db: Db;
  selectedCalendarsJson: h.State<string>;
}) => {
  const calendars = db.query(
    "SELECT calendar_id, name FROM icalendar",
    ["calendarId", "name"],
    [],
  );
  const selectedCalendars = h.derive<Array<number>>(() => {
    const calendarsVal = calendars.val;
    return JSON.parse(selectedCalendarsJson.val).filter(
      (calId: number) =>
        calendarsVal !== "loading" &&
        calendarsVal !== "error" &&
        calendarsVal.some((val) => val.calendarId === calId),
    );
  });

  const expanded = h.state(false);

  h.derive(() => {
    if (calendars.oldVal === "loading" && calendars.val.length === 0) {
      expanded.val = true;
    }
  });

  h.derive(() => {
    if (expanded.val) {
      document.body.classList.add("overflow-hidden");
      document.body.classList.add("fixed");
    } else {
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("fixed");
    }
  });

  return (
    <div className="relative flex">
      <a
        href="javascript:void(0)"
        className="rounded-lg border-2 border-blue-200 p-1 text-blue-200 hover:text-blue-500"
        onclick={(ev) => {
          ev.preventDefault();
          expanded.val = !expanded.val;
        }}
      >
        {() =>
          `${selectedCalendars.val.length} ${selectedCalendars.val.length === 1 ? "calendar" : "calendars"} ${expanded.val ? "▲" : "▼"}`
        }
      </a>
      {() => {
        if (!expanded.val) {
          return "";
        }
        if (calendars.val === "loading") {
          return "";
        }
        if (calendars.val === "error") {
          return "Something went wrong.";
        }
        return (
          <div>
            <div
              className="fixed left-0 top-0 z-10 h-screen w-screen sm:bg-transparent bg-white bg-opacity-75"
              onclick={(ev) => {
                ev.preventDefault();
                expanded.val = false;
              }}
            />
            <div className="sm:shadow-black-800 fixed left-[5%] top-[5%] z-10 flex w-[90%] flex-col overflow-y-auto bg-white p-4 sm:absolute sm:top-[35px] sm:mb-2 h-96 min-h-96 sm:w-96 rounded-lg border-2 shadow-xl">
              <a
                href="javascript:void(0)"
                className="absolute right-2 top-2 rounded-full bg-white sm:hidden"
                onclick={(ev) => {
                  ev.preventDefault();
                  expanded.val = false;
                }}
              >
                ✕
              </a>
              <form className="mb-12">
                {calendars.val.map((cal) => (
                  <div>
                    <input
                      type="checkbox"
                      id={`callist-box-${cal.calendarId}`}
                      checked={() =>
                        selectedCalendars.val.includes(cal.calendarId as number)
                      }
                      onchange={(ev: InputEvent) => {
                        const calId = cal.calendarId;
                        const selected = (ev.currentTarget as HTMLInputElement)
                          .checked;
                        selectedCalendarsJson.val = JSON.stringify([
                          ...selectedCalendars.val.filter(
                            (id: number) => id !== calId,
                          ),
                          ...(selected ? [calId] : []),
                        ]);
                      }}
                    />{" "}
                    <label htmlFor={`callist-box-${cal.calendarId}`}>
                      {cal.name}
                    </label>
                    <a
                      href="javascript:void(0)"
                      className="text-red-500 font-bold pl-2"
                      onclick={(ev: MouseEvent) => {
                        ev.preventDefault();
                        db.mutate(
                          "DELETE FROM icalendar WHERE calendar_id = ?1",
                          cal.calendarId,
                        );
                      }}
                    >
                      ✕
                    </a>
                  </div>
                ))}
              </form>
              <ImportIcs
                db={db}
                selectedCalendarsJson={selectedCalendarsJson}
                expanded={expanded}
              />
            </div>
          </div>
        );
      }}
    </div>
  );
};

export default function Filters({
  db,
  selectedCalendars,
}: {
  db: Db;
  selectedCalendars: h.State<string>;
  dtStart: h.State<string>;
  dtEnd: h.State<string>;
}) {
  return () => {
    return (
      <div className="flex gap-2">
        <div className="mb-4 border-blue-500">
          <CalendarPicker db={db} selectedCalendarsJson={selectedCalendars} />
        </div>
      </div>
    );
  };
}
